import { startCallback } from 'Pages/SmsQueue/recoil/callbacks/callbacks'
import { atom, selector } from 'recoil'

export const modalStopSendingState = atom({
  key: 'campaignsSendStatusModalStopSendingState',
  default: {
    show: false,
    idSending: undefined,
    mode: undefined
  }
})

export const modalFasciaDiNonDisturboState = atom({
  key: 'campaignsSendStatusmodalFasciaDiNonDisturboState',
  default: {
    show: false,
    idSending: undefined,
    enable: false,
    isFirstConfiguration: true,
    loading: false,
    messaggeSubject: '',
    idMessage: undefined,
    isValid: true,
    Start: {
      hours: 0,
      minutes: 0
    },
    End: {
      hours: 7,
      minutes: 0
    }
  }
})

export const fasciaDiNonDisturboInvalidSelector = selector({
  key: 'campaignsSendStatusSetFasciaDiNonDisturboValid',
  get: ({ get }) => {
    const { Start, End, enable } = get(modalFasciaDiNonDisturboState)
    if (Start.hours === End.hours && Start.minutes === End.minutes && enable) {
      return true
    } else {
      return false
    }
  }
})

export const modalStopCampaignState = atom({
  key: 'campaignsSendStatusModalStopCampaignState',
  default: {
    show: false,
    idSending: undefined,
    idSource: undefined,
    mode: undefined
  }
})

export const modalDeleteSendingState = atom({
  key: 'campaignsSendStatusModalDeleteSendingState',
  default: {
    show: false,
    idSending: undefined
  }
})

export const modalSendingSegmentationState = atom({
  key: 'campaignsSendStatusModalSendingSegmentationState',
  default: {
    show: false,
    loading: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    groups: [],
    excludedGroups: [],
    filters: [],
    section: 'groups',
    idMessage: undefined,
    idSending: undefined,
    simulationEnabled: false,
    simulationLoading: false,
    simulationLoaded: false,
    simulationResult: undefined,
    simulationDiff: undefined
  }
})

export const modalScheduleSendingState = atom({
  key: 'campaignsSendStatusModalScheduleSendingState',
  default: {
    show: false,
    planningType: undefined,
    idSending: undefined,
    idList: undefined,
    startDate: undefined,
    timeZoneCode: undefined,
    startDateSmart: undefined,
    timeZoneCodeSmart: undefined,
    smartPlanningError: undefined,
    countImmediate: undefined,
    error: undefined,
    severity: undefined,
    sending: false
  }
})
